import {
  createSlice,
} from "@reduxjs/toolkit";
import DeviceModel from "../../models/DeviceModel";

const SLICE_NAME = "freqAnalysis";

type SmallChannelModel = {
  technologyConfigurationId: number,
  technologyName: string,
  channels: { centralFrequencyHz: string, bandwidth: string } []
}

type FrequencyAnalysisState = {
  channelsForD3: SmallChannelModel[],
  deviceList: DeviceModel[],
  range: [ string, string ];
  stepCount: number | null;
  maxNumberOfDevices: number | null;
  selectedTechnologyId: number;
  selectedDeviceId: number;
}

const initialState: FrequencyAnalysisState = {
  channelsForD3: [],
  deviceList: [],
  range: [ '', '' ],
  stepCount: null,
  maxNumberOfDevices: null,
  selectedTechnologyId: 0,
  selectedDeviceId: 0,
};

export const freqAnalysisSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    setChannelsForD3(state, action) {
      state.channelsForD3 = action.payload;
    },
    setDeviceList(state, action) {
      state.deviceList = action.payload;
    },
    setRangeWithUnits(state, action) {
      state.range = action.payload;
    },
    setStepCont(state, action) {
      state.stepCount = parseInt(action.payload);
    },
    setMaxNumberOfDevices(state, action) {
      state.maxNumberOfDevices = parseInt(action.payload);
    },
    setTechnologyId(state, action) {
      state.selectedTechnologyId = action.payload;
    },
    setDeviceId(state, action) {
      state.selectedDeviceId = action.payload;
    },
    clearFAData(state) {
      state.channelsForD3 = [];
      state.deviceList = [];
      state.range = [ '', '' ];
      state.stepCount = null;
      state.maxNumberOfDevices = null;
      state.selectedTechnologyId = 0;
      state.selectedDeviceId = 0;
    }
  }
});

export const {
  setChannelsForD3,
  setDeviceList,
  setRangeWithUnits,
  setStepCont,
  setMaxNumberOfDevices,
  setTechnologyId,
  setDeviceId,
  clearFAData,
} = freqAnalysisSlice.actions;

